import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';

const override = css`
	display: block;
	margin: 0 auto;
	border-color: red;
`;

class AccountHolderLoader extends Component {
	render() {
		return (
			<div style={{ textAlign: 'center', marginTop: '30px' }}>
				<BeatLoader css={override} sizeUnit={'px'} size={10} color={'#6ab3c1'} loading={true} />
			</div>
		);
	}
}

export default AccountHolderLoader;
